import './bootstrap';
import '../css/app.css';

import {createSSRApp, h, reactive} from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from '../../vendor/tightenco/ziggy/dist/vue.m';
import {createI18n} from 'vue-i18n';
import {messages} from '@/i18n.js';
import VueTippy from 'vue-tippy';
import VuePapaParse from 'vue-papa-parse';
import { initYandexMetrika, trackPageView } from './utils/yandexMetrika';
import { router } from '@inertiajs/vue3';
import vue3GoogleLogin from 'vue3-google-login';

const appName = import.meta.env.VITE_APP_NAME || 'ProductLand';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

const i18n = createI18n({
    legacy: false,
    locale: 'ru', // set locale
    fallbackLocale: 'ru',
    messages,
    warnHtmlMessage: false
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({el, App, props, plugin}) {
        const globalState = reactive({
            openMainSideMenu: false
        });

        const app = createSSRApp({render: () => h(App, props)})
            .use(plugin)
            .use(i18n)
            .use(
                VueTippy,
                {
                    hideOnClick: true,
                    maxWidth: 350,
                    directive: 'tippy',
                    component: 'tippy',
                    componentSingleton: 'tippy-singleton',
                    defaultProps: {
                        placement: 'top',
                        allowHTML: true,
                        touch: false
                    }
                }
            )
            .use(VuePapaParse)
            .use(ZiggyVue)
            .provide('globalState', globalState);

        if (typeof window !== 'undefined') {
            if (GOOGLE_CLIENT_ID) {
                app.use(vue3GoogleLogin, {
                    clientId: GOOGLE_CLIENT_ID
                });
            } else {
                console.warn('Google Client ID is not set. Google Sign-In will not work.');
            }
        }

        // Initialize Yandex.Metrika only on client side
        if (typeof window !== 'undefined') {
            try {
                initYandexMetrika();
                if (router) {
                    router.on('navigate', trackPageView);
                }
            } catch (e) {
                console.error('Error initializing Yandex.Metrika:', e);
            }
        }

        return app.mount(el);
    },
    progress: {
        color: '#4B5563'
    }
});
